import type { Milestone } from "../../shared/route/index.ts";

export interface CelebrationState { list: Milestone[]; idx: number }

export default function Celebration({ cel, onward }: { cel: CelebrationState; onward: () => void }) {
  const cur = cel.list[cel.idx];
  const more = cel.list.length - cel.idx > 1;
  return (
    <div className="cel-scrim" role="dialog" aria-modal="true" aria-labelledby="cel-title">
      <div className="cel-stack">
        {more && <div className="cel-peek two" />}
        {more && <div className="cel-peek one" />}
        <div className="cel-card" key={cur.mile}>
          <div className="cel-inner">
            <div className="medallion">
              <svg width="42" height="42" viewBox="0 0 16 16" aria-hidden="true"><use href={`#mi-${cur.icon ?? "home"}`} /></svg>
            </div>
            <div className="cel-over">Milestone · Mile {Math.round(cur.mile).toLocaleString("en-US")}</div>
            <h2 id="cel-title" className="cel-title">{cur.mapLabel ?? cur.title}</h2>
            <div className="divider"><i /><b>◆</b><i /></div>
            <p className="cel-flavor">{cur.flavor ?? "A milestone on the long road."}</p>
            {cel.list.length > 1 && <div className="cel-count">{cel.idx + 1} of {cel.list.length} milestones this outing</div>}
            <button className="btn-primary block" onClick={onward} autoFocus>Onward</button>
          </div>
        </div>
      </div>
    </div>
  );
}
